import React from 'react';
import PropTypes from 'prop-types';
import { statistics } from '../../../../constants';
import sty from '../../WebCv/WebCv.module.css';

const List = (props) => {
    List.propTypes = {
        contents: PropTypes.arrayOf(
            PropTypes.shape({
                content: PropTypes.string.isRequired,
                years: PropTypes.number.isRequired
            })
        ).isRequired
    };
    const contents = props.contents;

    //経験年数に応じて凡例の色設定
    const setColor = (years, legend) => {
        return legend <= years  ? sty['on'] : '';
    }

    return (
        <>
            {contents.map((data, i) => (
                <div className={sty['cv__statistics-list-con']} key={i}>
                    <dt className={sty['cv__statistics-list-label']}>{data.content}</dt>
                    <dd className={sty['cv__statistics-list-items']}>
                        <span className={`${sty['cv__statistics-list-item']} ${setColor(data.years, statistics.TERMS.LESS_THAN_ONE)}`}></span>
                        <span className={`${sty['cv__statistics-list-item']} ${setColor(data.years, statistics.TERMS.ONE_OR_MORE)}`}></span>
                        <span className={`${sty['cv__statistics-list-item']} ${setColor(data.years, statistics.TERMS.TWO_OR_MORE)}`}></span>
                        <span className={`${sty['cv__statistics-list-item']} ${setColor(data.years, statistics.TERMS.THREE_OR_MORE)}`}></span>
                        <span className={`${sty['cv__statistics-list-item']} ${setColor(data.years, statistics.TERMS.FIVE_OR_MORE)}`}></span>
                    </dd>
                </div>
            ))}
        </>
    )
}

const Statistics = ({ data }) => {
    Statistics.propTypes = {
        data: PropTypes.object,
    };

    // 大カテゴリが空の場合はfalseを設定して、データがある場合はそのまま設定
    const statisticsData = {};
    if (data) {
        Object.keys(data).forEach(key => {
            statisticsData[key] = Object.keys(data[key]).length > 0 ? data[key] : false;
        });
    }
    
    // 全てのセクションが空（false）かどうかをチェック
    const hasData = Object.values(statisticsData).some(value => value !== false);
    
    return !hasData ? 
        <div>統計データがありません</div>
    : (
        <>
            <div className={sty['cv__statistics']}>
                <ul className={sty['cv__statistics-ex']}>
                    <li className={sty['cv__statistics-ex-items']}>
                        <span className={sty['cv__statistics-ex-item']}>■</span>
                        <span className={sty['cv__statistics-ex-label']}>1年未満</span>
                    </li>
                    <li className={sty['cv__statistics-ex-items']}>
                        <span className={sty['cv__statistics-ex-item']}>■</span>
                        <span className={sty['cv__statistics-ex-item']}>■</span>
                        <span className={sty['cv__statistics-ex-label']}>1年以上</span>
                    </li>
                    <li className={sty['cv__statistics-ex-items']}>
                        <span className={sty['cv__statistics-ex-item']}>■</span>
                        <span className={sty['cv__statistics-ex-item']}>■</span>
                        <span className={sty['cv__statistics-ex-item']}>■</span>
                        <span className={sty['cv__statistics-ex-label']}>2年以上</span>
                    </li>
                    <li className={sty['cv__statistics-ex-items']}>
                        <span className={sty['cv__statistics-ex-item']}>■</span>
                        <span className={sty['cv__statistics-ex-item']}>■</span>
                        <span className={sty['cv__statistics-ex-item']}>■</span>
                        <span className={sty['cv__statistics-ex-item']}>■</span>
                        <span className={sty['cv__statistics-ex-label']}>3年以上</span>
                    </li>
                    <li className={sty['cv__statistics-ex-items']}>
                        <span className={sty['cv__statistics-ex-item']}>■</span>
                        <span className={sty['cv__statistics-ex-item']}>■</span>
                        <span className={sty['cv__statistics-ex-item']}>■</span>
                        <span className={sty['cv__statistics-ex-item']}>■</span>
                        <span className={sty['cv__statistics-ex-item']}>■</span>
                        <span className={sty['cv__statistics-ex-label']}>5年以上</span>
                    </li>
                </ul>
                {statisticsData.server && (
                <>
                    <h2 className={sty['cv__statistics-tit']}>サーバー</h2>
                        {Object.keys(statisticsData.server).map((category, index) => (
                            <React.Fragment key={`server-${category}-${index}`}>
                                <div className={sty['cv__statistics-txt']}>{category}</div>
                                    <div className={sty['cv__statistics-wrap']}>
                                    <dl className={sty['cv__statistics-list']}>
                                        <List
                                            contents={statisticsData.server[category]}
                                        />
                                    </dl>
                                </div>
                            </React.Fragment>
                        ))}
                </>
                )}
                {statisticsData.client && (
                <>
                    <h2 className={sty['cv__statistics-tit']}>クライアント</h2>
                        {Object.keys(statisticsData.client).map((category, index) => (
                            <React.Fragment key={`client-${category}-${index}`}>          
                                <div className={sty['cv__statistics-txt']}>{category}</div> 
                                <div className={sty['cv__statistics-wrap']}>
                                    <dl className={sty['cv__statistics-list']}>
                                        <List
                                            contents={statisticsData.client[category]}
                                        />
                                    </dl>
                                </div>
                            </React.Fragment>
                        ))}
                </>
                )}
                {statisticsData.dev && (
                <>
                    <h2 className={sty['cv__statistics-tit']}>開発</h2>
                        {Object.keys(statisticsData.dev).map((category, index) => (
                            <React.Fragment key={`dev-${category}-${index}`}>
                                <div className={sty['cv__statistics-txt']}>{category}</div>
                                <div className={sty['cv__statistics-wrap']}>
                                    <dl className={sty['cv__statistics-list']}>
                                        <List
                                            contents={statisticsData.dev[category]}
                                        />
                                    </dl>
                                </div>
                            </React.Fragment>
                        ))}
                </>
                )}
                {statisticsData.cloud && (
                <>
                    <h2 className={sty['cv__statistics-tit']}>クラウド</h2>
                        {Object.keys(statisticsData.cloud).map((category, index) => (
                            <React.Fragment key={`cloud-${category}-${index}`}>
                                <div className={sty['cv__statistics-txt']}>{category}</div>
                                <div className={sty['cv__statistics-wrap']}>
                                    <dl className={sty['cv__statistics-list']}>
                                        <List
                                            contents={statisticsData.cloud[category]}
                                        />
                                    </dl>
                                </div>
                            </React.Fragment>
                        ))}
                </>
                )}
                {statisticsData.pc && (
                <>
                    <h2 className={sty['cv__statistics-tit']}>PC</h2>
                        {Object.keys(statisticsData.pc).map((category, index) => (
                            <React.Fragment key={`pc-${category}-${index}`}>
                                <div className={sty['cv__statistics-txt']}>{category}</div>
                                <div className={sty['cv__statistics-wrap']}>
                                    <dl className={sty['cv__statistics-list']}>
                                        <List
                                            contents={statisticsData.pc[category]}
                                        />
                                    </dl>   
                                </div>
                            </React.Fragment>
                        ))}
                </>
                )}
                {statisticsData.network && (
                <>
                    <h2 className={sty['cv__statistics-tit']}>ネットワーク</h2>
                        {Object.keys(statisticsData.network).map((category, index) => (
                            <React.Fragment key={`network-${category}-${index}`}>
                                <div className={sty['cv__statistics-txt']}>{category}</div>
                                <div className={sty['cv__statistics-wrap']}>
                                    <dl className={sty['cv__statistics-list']}>
                                        <List
                                            contents={statisticsData.network[category]}
                                        />
                                    </dl>
                                </div>
                            </React.Fragment>
                        ))}
                </> 
                )}
            </div>
        </>
    );
};

export default Statistics;